export const ResponseTypes = {
  advanced: 'Advanced Multi',
  simple: 'Simple',
};
